export interface IRole{
    id:string,
    name:string,
}

export const ROLE_STORE_ACTIONS = {
    RESET_ROLES:'ROLES:RESET',
}